export default (state = {}, {userId, res}: any) => {
  return {
    ...state,
    BBBBanner: {
      [userId]: res,
    },
  };
};
